/**
 * Created by Moment on 16/8/25.
 */
module.exports = {
  /**
   * 得到固定时间戳
   * @param day  2015-02-03 10:00:00
   * @returns {number}
   */
  toArray (list) {
    let result = []
    if (!this.isNullOrEmpty(list)) {
      for (let i in list) {
        result.push(list[i])
      }
    }
    return result
  },
  /**
   * 判断是否为空
   * @param  {[type]}  obj [description]
   * @return {Boolean}     [description]
   */
  isNullOrEmpty (obj) {
    if (obj === undefined || obj === null || obj === '' || obj === 0) {
      return true
    }
    return false
  },
  /**
   * 取出整数二进制中位为1的数值
   * @param intVal
   * @return array
   */
  extractValues (intVal) {
    let rtn = [], step = 0
    while (intVal > 0) {
      if (intVal % 2 == 1) {
        rtn.push(1 << step)
      }
      step++
      intVal >>= 1
    }
    return rtn
  }
}
